import React from "react";
import { Row } from "antd";
import TextField from "../Common/TextField";
import { useSelector, useDispatch } from "react-redux";
import {linkItemUpdated} from "../../store/actions/WebchatBrandingElementsAction";
import updateStyling from "utility/PortalPostMessage";

export default function WebchatBrandingTabMenuLinks({ onDataChange = () => {} }) {
    const dispatch = useDispatch();
    const { previewState } = useSelector((state) => state.WebchatBrandingElementsReducer);
    const BRAND_FAQ_LINK_KEY = "FAQLink";
    const BRAND_SUPPORT_LINK_KEY = "SupportLink";
    const BRAND_SHOP_LINK_KEY = "ShopLink";

    return (
        <>
            <Row gutter={[10, 10]} style={{ marginLeft: 10 }}>

                <TextField
                    label="FAQ"
                    disabled={false}
                    onChange={(value) => {
                        updateStyling(document, BRAND_FAQ_LINK_KEY, value)
                        dispatch(linkItemUpdated(BRAND_FAQ_LINK_KEY,value))
                        onDataChange();
                    }}
                    initialValue={previewState[BRAND_FAQ_LINK_KEY]}
                />

                <TextField
                    label="Customer Support"
                    disabled={false}
                    onChange={(value) => {
                        updateStyling(document, BRAND_SUPPORT_LINK_KEY, value)
                        dispatch(linkItemUpdated(BRAND_SUPPORT_LINK_KEY,value))
                        onDataChange();
                    }}
                    initialValue={previewState[BRAND_SUPPORT_LINK_KEY]}
                />

                <TextField
                    label="Shop"
                    disabled={false}
                    onChange={(value) => {
                        updateStyling(document, BRAND_SHOP_LINK_KEY, value)
                        dispatch(linkItemUpdated(BRAND_SHOP_LINK_KEY,value))
                        onDataChange();
                    }}
                    initialValue={previewState[BRAND_SHOP_LINK_KEY]}
                />
            </Row>
        </>
    );
}
